import React from 'react';

import { Flex, rem, Text, useColorModeValue } from '@vimeo/bokeh';
import { Checkmark } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { IPollOption } from '@vimeo/live-core/types/interaction_tools';

import { createInteractionDomName } from '../../../../libs/shared/utils/dom/identifying';

interface IPollOptionVotesBarProps extends IBaseDomElementProps {
  isBold?: boolean;
  option: IPollOption;
}

export function PollOptionVotesBarHidden({
  id,
  className = createInteractionDomName('poll-option-votes'),
  option,
  isBold = false,
}: IPollOptionVotesBarProps) {
  const barBackgroundColor: string = useColorModeValue('slate.200', 'grayscale.700');

  return (
    <Flex
      id={id}
      className={className}
      width={'100%'}
      overflow={'hidden'}
      position={'relative'}
      direction={'column'}
      justifyContent={'center'}
    >
      <Flex
        width={'100%'}
        justifyContent={'space-between'}
        margin={`${rem(4)} 0`}
        padding={`${rem(4)} 0`}
      >
        <Flex overflow={'hidden'} alignItems={'center'}>
          <Text
            className={createInteractionDomName(className, 'option-text')}
            variant="body-xl"
            fontSize={'text-sm'}
            lineHeight={rem(18)}
            marginRight={rem(8)}
          >
            {option.text}
          </Text>

          {option.isVotedByMe ? (
            <Checkmark
              className={createInteractionDomName(className, 'your-answer-icon')}
              data-testid={'yourAnswerIcon'}
              height={rem(14)}
            />
          ) : null}
        </Flex>
      </Flex>

      <Flex
        className={createInteractionDomName(className, 'bar')}
        overflow={'hidden'}
        borderRadius={isBold ? rem(8) : rem(4)}
        height={isBold ? rem(8) : rem(4)}
        backgroundColor={barBackgroundColor}
      >
        <Flex
          position={'absolute'}
          width={0}
          zIndex={5}
          borderRadius={isBold ? rem(8) : rem(4)}
          height={isBold ? rem(8) : rem(4)}
          background={'status-info-primary'}
        />
      </Flex>
    </Flex>
  );
}
